import type { MailboxInfo } from 'owa-client-types';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import {
    isEnabledForFrontierCopilotAudience,
    type FrontierFlightConfig,
} from './isEnabledForFrontierCopilotAudience';
import { isCopilotLicensedAndEnabledUser } from './isCopilotLicensedAndEnabledUser';

const navigationFrontierFlights: FrontierFlightConfig = {
    publicFlight: 'mon-copilot-bizchat-agent-module-switch-frontier-public',
    privateTapFlight: 'mon-copilot-bizchat-agent-module-switch-frontier-private-tap',
    privateStagingFlight: 'mon-copilot-bizchat-agent-module-switch-frontier-private-staging',
    privateInfluencerFlight: 'mon-copilot-bizchat-agent-module-switch-frontier-private-influencer',
};

/**
 * Single check for whether Copilot Bizchat Agent module switch is enabled.
 * Requires a copilot license, then returns true if EITHER:
 * - The global `mon-copilot-bizchat-agent-module-switch` flight is on (conventional rollout), OR
 * - The user is a licensed frontier user and the frontier flight for their type is enabled
 */
export function isBizchatAgentSetOnModuleSwitchEnabled(
    mailboxInfo: MailboxInfo = getGlobalSettingsAccountMailboxInfo()
): boolean {
    if (!isCopilotLicensedAndEnabledUser(mailboxInfo)) {
        return false;
    }
    return (
        isGlobalFeatureEnabled('mon-copilot-bizchat-agent-module-switch') ||
        isEnabledForFrontierCopilotAudience(mailboxInfo, navigationFrontierFlights)
    );
}
